import {
  SET_TEEUP_NAME,
  SET_TEEUP_IMAGE,
  SET_TEEUP_MESSAGE,
  SET_INVITEES,
  SET_IS_INVITEES_OPEN,
  APPLY_AUTO_COVER,
} from "./actionTypes"

export const CreateTeeUpReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_TEEUP_NAME:
      return {
        ...state,
        name: payload,
      }
    case SET_TEEUP_IMAGE:
      // A real user pick (the SelectImage screen's UploadFromDevice/SearchUnsplashPhoto tabs) --
      // marks the cover as manually chosen so the one-time auto-adjust never fires/overrides it.
      return {
        ...state,
        image: payload,
        coverManuallySet: true,
      }
    case APPLY_AUTO_COVER:
      // STRICT ONCE + never-override-manual guard, enforced here too (defense in depth on top of
      // the caller's own check in useCreateTeeUp's maybeAutoAdjustCover).
      if (state.coverManuallySet || state.coverAutoAdjusted) return state
      return {
        ...state,
        image: payload,
        coverAutoAdjusted: true,
      }
    case SET_TEEUP_MESSAGE:
      return {
        ...state,
        message: payload,
      }
    case SET_INVITEES:
      return {
        ...state,
        invitees: payload,
      }
    case SET_IS_INVITEES_OPEN:
      return {
        ...state,
        isInviteesOpen: payload,
      }
    default: {
      return state
    }
  }
}
